import CabifyFull from 'marketing-website/components/icons/CabifyFull';
import statsImage from 'marketing-website/media/images/pages/case-studies/cabify/stats2@2x.jpg';
import image00a from 'marketing-website/media/images/pages/case-studies/cabify/image-00-a@2x.jpg';
import image00b from 'marketing-website/media/images/pages/case-studies/cabify/image-00-b@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/cabify/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/cabify/image-01-b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/cabify/image-02-a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/cabify/image-02-c@2x.jpg';
import imageQuote from 'marketing-website/media/images/pages/case-studies/cabify/quote@2x.jpg';
import singleImage from 'marketing-website/media/images/pages/case-studies/cabify/image-03@2x.jpg';

const cabifyAssets = {
  heroLogo: CabifyFull,
  statsImage: {
    src: statsImage,
    srcSet: statsImage,
    alt: '',
  },
  stats: [
    {
      id: 0,
      stat: '15 mins',
      title: 'Feedback time',
      copy:
        'Marvel’s commenting and collaboration features closed feedback loops for Cabify.',
    },
    {
      id: 1,
      stat: '1 week',
      title: 'Shipping time',
      copy:
        'Cabify accelerate their design process through prototyping and testing with Marvel',
    },
    {
      id: 2,
      stat: '400%',
      title: 'Time reduction',
      copy:
        'The team have seen a 400% reduction in time it takes to design and prototype new features',
    },
  ],
  doubleImages: {
    zero: [
      {
        src: image00a,
        maxWidth: 556,
        alt: '',
      },
      {
        src: image00b,
        maxWidth: 556,
        alt: '',
      },
    ],
    first: [
      {
        src: image01a,
        maxWidth: 550,
        alt: '',
      },
      {
        src: image01b,
        maxWidth: 494,
        alt: '',
      },
    ],
    second: [
      {
        src: imageQuote,
        maxWidth: 556,
        alt: '',
      },
      {
        maxWidth: 490,
        copy:
          '"Marvel has become the first touch point between designers and the rest of the team."',
      },
    ],
    third: [
      {
        src: image02a,
        maxWidth: 536,
        alt: '',
      },
      {
        src: image02b,
        maxWidth: 550,
        alt: '',
      },
    ],
  },
  singleImages: {
    first: {
      src: singleImage,
      maxWidth: 1141,
      alt: '',
    },
  },
};

export default cabifyAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/cabify.js